<div class="lesson-detail-wrap">
  <a class="lesson-back" routerLink="/guitar-app/lessons">← All lessons</a>

  <ng-container *ngIf="lesson; else notFound">
    <span class="lesson-level" [class.advanced]="lesson.level === 'Advanced'">{{ lesson.level }}</span>
    <h2 class="lesson-detail-title">{{ lesson.title }}</h2>

    <ng-container *ngFor="let block of lesson.blocks" [ngSwitch]="block.kind">
      <h3 class="ld-heading"   *ngSwitchCase="'heading'">{{ $any(block).text }}</h3>
      <p  class="ld-paragraph" *ngSwitchCase="'paragraph'">{{ $any(block).text }}</p>
      <div class="ld-callout"  *ngSwitchCase="'callout'">{{ $any(block).text }}</div>
      <p  class="ld-link"      *ngSwitchCase="'link'">
        <a [href]="$any(block).url" target="_blank" rel="noopener">{{ $any(block).label }} ↗</a>
        <span class="ld-link-note" *ngIf="$any(block).note"> — {{ $any(block).note }}</span>
      </p>
      <app-fret-diagram *ngSwitchCase="'diagram'" [diagram]="$any(block).diagram"></app-fret-diagram>
    </ng-container>
  </ng-container>

  <ng-template #notFound>
    <p class="lesson-not-found">Lesson not found. <a routerLink="/guitar-app/lessons">Back to lessons</a>.</p>
  </ng-template>
</div>
